type OrientationParams = {
  site: string;
  optionsCount: number;
};

// Set radio group orientation based on site and number of options
export const getOrientation = ({ site, optionsCount }: OrientationParams) => {
  let orientation = "vertical";

  if (site !== "comparethemarket" && optionsCount <= 2) {
    orientation = "horizontal";
  }

  return orientation;
};
